module.exports = __webpack_public_path__ + "static/media/0-blue-blot.576e05a3.png";